import React from 'react';
import Layout from './src/layout/Layout';

export const wrapPageElement = ({ element, props }) => {
	return <Layout {...props}>{element}</Layout>;
};

export { default as wrapRootElement } from './src/state/ReduxWrapper';
